module.exports = __webpack_public_path__ + "img/test_r6.72cd1830.png";